import dayjs from 'dayjs';
import edjsParser from 'editorjs-parser';
import { ContentHubMedifitMedicalResponse } from '../dto/medifit-medical.dto';
import { ContentHubMedifitMedical } from '../model/medifit-medical.model';

export class MedifitMedicalMapper {
    public mapDtoToModel(dto: ContentHubMedifitMedicalResponse): ContentHubMedifitMedical {
        return {
            title: dto.title,
            instructions: dto.instructions ? new edjsParser().parse(JSON.parse(dto.instructions)) : null,
            createdAt: dto.createdAt ? dayjs(dto.createdAt) : null,
            updatedAt: dto.updatedAt ? dayjs(dto.updatedAt) : null,
            publishedAt: dto.publishedAt ? dayjs(dto.publishedAt) : null,
            hdApp: dto.hdApp,
            bsId: dto.bsId,
            locale: dto.locale,
        };
    }
}
